class Header {
    constructor() {
        this.$body = document.querySelector("body");
        this.$header = document.querySelector("[data-header]");
        this.$button = this.$header
            ? this.$header.querySelector("[data-header-toggle]")
            : undefined;
    }

    init() {
        if (this.$button) {
            this.$button.addEventListener("click", () => {
                this.collapseMenu();
                this.fireCollapseEvent();
            });
        }
    }

    collapseMenu() {
        this.$body.classList.toggle("navigation-is-open");
        this.$button.setAttribute(
            "aria-expanded",
            this.ariaExpandedAttribute()
        );
        this.$header.classList.toggle("is-open");
    }

    fireCollapseEvent() {
        const eventname =
            this.$button.getAttribute("aria-expanded") === "true"
                ? "header-open"
                : "header-closed";
        const event = new CustomEvent(eventname);
        document.dispatchEvent(event);
    }

    ariaExpandedAttribute() {
        return this.$button.getAttribute("aria-expanded") === "true"
            ? "false"
            : true;
    }
}

const header = new Header();
header.init();
